import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, WrenchIcon } from 'lucide-react';
import { site } from '../data/site';
export function ContactDetails({
  dark = false
}: {
  dark?: boolean;
}) {
  const base = dark ? 'border-white/10 bg-ink-800 text-steel-300' : 'border-steel-200 bg-white text-steel-500';
  const heading = dark ? 'text-white' : 'text-ink';
  return <div className={`rounded-sm border shadow-card ${base}`} data-id="element-35" data-mp="3aml7wi66j7s">
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-36" data-mp="h6qarci3m3dx" />
      <div className="space-y-6 p-6 sm:p-8" data-id="element-37" data-mp="d6zewudpsx2j">
        <div data-id="element-38" data-mp="d67ijhcamvb7">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-safety" data-id="element-39" data-mp="d4d7qvuqkjku">
            Free Estimates &amp; Plumbing
          </p>
          <a href={site.estimatePhone.href} className={`mt-1 block font-display text-3xl font-bold tracking-tight ${heading} hover:text-safety`} data-id="element-40" data-mp="ly9ileiga9ky">
            {site.estimatePhone.display}
          </a>
          <p className="mt-1 text-sm" data-id="element-41" data-mp="vyigqxw0652z">
            Also written as {site.estimatePhone.alt}
          </p>
        </div>

        <div className="rounded-sm border border-safety/40 bg-safety-100 p-4" data-id="element-42" data-mp="d65yncj55yw4">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-safety-600" data-id="element-43" data-mp="i3pkoym2zfym">
            <WrenchIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="m3gbh2blxw35" />
            Plumbing
          </p>
          <a href={site.plumbingPhone.href} className="mt-1 block font-display text-2xl font-bold tracking-tight text-ink hover:text-safety-600" data-id="element-45" data-mp="r55im6vplply">
            {site.plumbingPhone.display}
          </a>
          <p className="mt-1 text-sm text-ink-600" data-id="element-46" data-mp="15t0ge1okqk5w">
            Leaky faucets, running toilet or frozen pipes — including emergency
            plumbing service.
          </p>
        </div>

        <ul className="space-y-4 text-sm" data-id="element-47" data-mp="1etgip7tkzl96">
          <li className="flex items-start gap-3" data-id="element-48" data-mp="1eurjcyrqccw2">
            <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-49" data-mp="1jsjavrogpwzq" />
            <span data-id="element-50" data-mp="1jq6u3hufxso9">
              <span className={`block font-semibold ${heading}`} data-id="element-51" data-mp="3fvejc3oy36dk">E-mail</span>
              <a href={site.emailHref} className="break-all hover:text-safety" data-id="element-52" data-mp="3ftbkcu5te2wp">
                {site.email}
              </a>
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-53" data-mp="3pm97jdlr4g1n">
            <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-54" data-mp="3kur8iv3agpjb" />
            <span data-id="element-55" data-mp="2grpbwfbu3wc">
              <span className={`block font-semibold ${heading}`} data-id="element-56" data-mp="2g8ibar7szx3">
                Mailing Address
              </span>
              {site.address.company}
              <br data-id="element-57" data-mp="3ukanhpnvrz8w" />
              {site.address.line1}
              <br data-id="element-58" data-mp="cf7jy9dkbval" />
              {site.address.city}, {site.address.state} {site.address.zip}
            </span>
          </li>
          <li className="flex items-start gap-3" data-id="element-59" data-mp="7ge44aaszs79">
            <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-safety" aria-hidden="true" data-id="element-60" data-mp="2e62eyyzy3qg9" />
            <span data-id="element-61" data-mp="2977qbgfar7o8">
              <span className={`block font-semibold ${heading}`} data-id="element-62" data-mp="297r9t1kli44d">Website</span>
              <a href={site.url} className="hover:text-safety" data-id="element-63" data-mp="op6zvj68e2vx">
                totalhomeimp.com
              </a>
            </span>
          </li>
        </ul>
      </div>
    </div>;
}